/**
 * Normalize API `key` values for React inputs (string) and RHF.
 * Supports null, numeric ids from legacy payloads, and empty keys (Angular allows).
 */
export function normalizeTemplateKey(value: unknown): string {
  if (value == null) return ''
  return String(value)
}
